import { render, staticRenderFns } from "./doctorLogin.vue?vue&type=template&id=2e3fb6e9&"
import script from "./doctorLogin.vue?vue&type=script&lang=js&"
export * from "./doctorLogin.vue?vue&type=script&lang=js&"
import style0 from "./doctorLogin.vue?vue&type=style&index=0&id=2e3fb6e9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports